// src/constants/index.js
export const CONSTANTS = {
  // Тайминги (в миллисекундах)
  TIMING: {
    CACHE_TTL: {
      USER: 5 * 60 * 1000,        // 5 минут
      TASK: 30 * 1000,            // 30 секунд
      TASK_LIST: 60 * 1000,       // 1 минута
    },
    DEBOUNCE: {
      SEARCH: 300,                 // 300 мс
      TYPING: 500,                 // 500 мс
    },
    RECONNECT: {
      BASE_DELAY: 1000,            // 1 секунда
      MAX_DELAY: 30000,            // 30 секунд
      MAX_ATTEMPTS: 5,
    },
    AUTO_REFRESH: 60000,           // 1 минута
    HEARTBEAT: 25000,              // 25 секунд
    TYPING_TIMEOUT: 3000,          // 3 секунды
    MESSAGE_EDIT_LIMIT: 300000,    // 5 минут
    TOAST_DURATION: 8000,          // 8 секунд
  },

  // Лимиты
  LIMITS: {
    USERS_CACHE_SIZE: 1000,
    MESSAGES_PER_PAGE: 50,
    TASKS_PER_PAGE_DEFAULT: 15,
    USERS_PER_PAGE_DEFAULT: 20,
    FILE_SIZE_MAX: 10 * 1024 * 1024, // 10 MB
    COMMENT_MAX_LENGTH: 5000,
    MESSAGE_MAX_LENGTH: 5000,
    TITLE_MAX_LENGTH: 255,
  },

  // Статусы задач
  TASK_STATUS: {
    OPEN: 'open',
    ASSIGNED: 'assigned',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled',
    REOPENED: 'reopened',
  },

  // Приоритеты задач
  TASK_PRIORITY: {
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high',
    URGENT: 'urgent',
  },

  // Категории задач
  TASK_CATEGORY: {
    TECHNICAL: 'technical',
    ADMINISTRATIVE: 'administrative',
    FEATURE_REQUEST: 'feature_request',
    BUG: 'bug',
    OTHER: 'other',
  },

  // Типы уведомлений
  NOTIFICATION_TYPE: {
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
    SYSTEM: 'system',
    TASK: 'task',
    CHAT: 'chat',
  },

  // Статусы уведомлений
  NOTIFICATION_STATUS: {
    UNREAD: 'unread',
    READ: 'read',
    ARCHIVED: 'archived',
  },

  // Роли пользователей
  USER_ROLE: {
    USER: 'user',
    MODERATOR: 'moderator',
    ADMIN: 'admin',
  },

  // Типы комнат чата
  CHAT_ROOM_TYPE: {
    PRIVATE: 'private',
    GROUP: 'group',
    TASK: 'task',
  },

  // Роли участников чата
  CHAT_PARTICIPANT_ROLE: {
    MEMBER: 'member',
    ADMIN: 'admin',
  },

  // Статусы сообщений чата
  CHAT_MESSAGE_STATUS: {
    SENT: 'sent',
    DELIVERED: 'delivered',
    READ: 'read',
    EDITED: 'edited',
    DELETED: 'deleted',
  },

  // HTTP статусы
  HTTP_STATUS: {
    OK: 200,
    CREATED: 201,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    VALIDATION_ERROR: 422,
    SERVER_ERROR: 500,
  },

  // WebSocket сообщения
  WS_MESSAGE_TYPE: {
    PING: 'ping',
    PONG: 'pong',
    SUBSCRIBE: 'subscribe',
    UNSUBSCRIBE: 'unsubscribe',
    ERROR: 'error',
    
    TASK_CREATED: 'task:created',
    TASK_UPDATED: 'task:updated',
    TASK_DELETED: 'task:deleted',
    TASKS_LIST_RESULT: 'tasks:list_result',
    
    NOTIFICATION: 'notification',
    NOTIFICATION_READ: 'notification_read',
    ALL_NOTIFICATIONS_READ: 'all_notifications_read',
    INITIAL_NOTIFICATIONS: 'initial_notifications',
    
    CHAT_NEW_MESSAGE: 'chat:new_message',
    CHAT_TYPING: 'chat:typing',
    CHAT_MESSAGE_READ: 'chat:message_read',
    CHAT_PARTICIPANT_ADDED: 'chat:participant_added',
    CHAT_PARTICIPANT_REMOVED: 'chat:participant_removed',
    CHAT_ROOM_LOCKED: 'chat:room_locked',
  },
};